<section class="my-5  text-center">


    <div class="col-xl-6  col-lg-8 col-md-12 mb-lg-0 mb-5 mx-auto text-center">


        <nav aria-label="Page navigation example">
            <ul class="pagination justify-content-center">
                <li  class="page-item" aria-current="page"><button  (click)="selectPage(1)"  class="page-link">1</button></li>
                <li class="page-item" [ngClass]="{'active':page==2}"><button (click)="selectPage(2)" class="page-link">2</button></li>
                <li class="page-item" [ngClass]="{'active':page==3}"><button (click)="selectPage(3)" class="page-link">3</button></li>
                <li class="page-item" [ngClass]="{'active':page==4}"><button (click)="selectPage(4)" class="page-link">4</button></li>
                <li class="page-item" [ngClass]="{'active':page==5}"><button (click)="selectPage(5)" class="page-link">5</button></li>
                <li class="page-item" [ngClass]="{'active':page==6}"><button (click)="selectPage(6)" class="page-link">6</button></li>
              
            </ul>
        </nav>


        <div class="text-left">

            <div *ngIf="page==1">
                <h2>Art des Hilfeangebotes</h2>
                <p>
                    Das Angebot von eo ipso richtet sich primär an Familien, Kinder und Jugendliche, sowie junge
                    Erwachsene.
                    Im Rahmen der ambulanten Jugendhilfe bietet eo ipso den Adressaten die Klärung der aktuellen
                    Lebenssituation und lösungsorientierte Perspektiv- und Ressourcenentwicklung, mit dem Ziel
                    Lebenswirklichkeit zukünftig gelingend selbsttätig zu gestalten, an.
                </p>

                <h2>Ziele und Rechtsgrundlagen</h2>
                <p>
                    Eo ipso erkennt in den Inhalten des § 1 SGBVIII und dem Art. 24 der Charta der Grundrechte der EU
                    (Förderung der Entwicklung, Erziehung zu einer eigenverantwortlichen und gemeinschaftsfähigen
                    Persönlichkeit, Anspruch auf Schutz und Fürsorge, Vorrangigkeit des Kindeswohles) das grundlegende
                    Ziel
                    seiner Arbeit; sie stellen den primären Rechtsbezug für unsere Arbeit mit Familien, Kindern und
                    jungen
                    Erwachsenen dar, hier insbesondere die Sicherung des Kindeswohls nach §1 Abs. 3 Satz 3 SGB VIII in
                    Verbindung mit § 8a SGB VIII.
                </p>
                <p>
                    Daraus folgend ergibt sich die Wiederherstellung der Erziehungsfähigkeit im Rahmen von Hilfe zur
                    Erziehung im Sinne des § 27 Abs. 1 SGB VIII als weiteres Ziel unserer Arbeit. Umgesetzt von eo ipso
                    werden in Bezug auf Hilfen zur Erziehung maßgeblich
                    § 27 Abs. 3 in Form von Aufsuchender Familientherapie (AFT) sowie die §§ 28-31 SGB VIII
                    (Erziehungsberatung, Soziale Gruppenarbeit, Erziehungsbeistand und Sozialpädagogische
                    Familienhilfe).
                </p>
                <p>
                    Eo ipso sieht in der Verselbständigung junger Erwachsener nach § 41 SGB VIII – hier auch
                    hinsichtlich
                    unbegleiteter minderjähriger Flüchtlinge, die die Volljährigkeit während der Hilfe erreichen –,
                    falls
                    erforderlich, eine notwendige Konsequenz aus den vorangegangenen Rechtsbezügen und Arbeitszielen.
                </p>
                <p>
                    Weiteres Ziel ist es, Kinder, Jugendliche und Eltern im Kontext hochstrittiger Trennungs- oder
                    Scheidungsverfahren zu begleiten und nach § 18 Abs. 3 Satz 1 und 3 SGB VIII in Angelegenheiten,
                    welche
                    das Umgangsrecht bzw. die Ausgestaltung der Umgangskontakte betreffen zu beraten und zu
                    unterstützen,
                    sowie Umgangskontakte zum Schutz des Kindeswohls zu begleiten.
                </p>
            </div>



            <div *ngIf="page==2">
                <h2>Fachliche Ausrichtung </h2>

                <p>
                    Jede Gründerin von eo ipso hat einen Diplomstudiengang der Sozialen Arbeit bzw. Sozialarbeit oder
                    Sozialpädagogik absolviert. Außerdem bringt jede einen Schatz an Lebens- und Berufserfahrung, sowie
                    vielfältige qualifizierte Weiterbildungen in den Träger ein. Durch den Zusammenschluss in Form von
                    eo ipso ergibt sich ein nutzenswerter Pool aus systemischen, kreativ- lösungsorientierten und
                    kunsttherapeutisch – pädagogischen Bereichen.
                    Durch die Zusatzausbildung der drei Gründerinnen zu Verfahrensbeiständen nach §158 FamFG bewegt sich
                    eo ipso sicher in den rechtlichen Rahmenbedingungen ambulanter Hilfen zur Erziehung und
                    gerichtlicher Verfahren, was insbesondere in der Begleitung hochzerstrittener Elternpaare im Rahmen
                    von Trennung und Scheidung für die Familien bereichernd und entlastend sein kann, insofern keine
                    Beruhigung der Situation hergeleitet werden kann.
                </p>
                <p>
                    Die frühzeitige und fundierte Einschätzung einer Kindeswohlgefährdung wird durch zertifizierte
                    Qualifikationen zu „insoweit erfahrenen Fachkräften“ nach § 8a SGB VIII gesichert.
                </p>
                <p>
                    Detailliert sind die einzelnen beruflichen Erfahrungen und Qualifikationen, sowie schwerpunktmäßige
                    Wirkungskreise den Kurzprofilen am Ende der Leistungsbeschreibung zu entnehmen.
                </p>
                <p>
                    Eine besondere und aktuelle Herausforderung sieht eo ipso in der Übernahme von Aufgaben im Bereich
                    Begleitung und Unterstützung im Rahmen von sozialpädagogischer Familienhilfe oder
                    Erziehungsbeistandschaften von Familien mit Migrationshintergrund, insbesondere seien hier
                    Flüchtlingsfamilien aus Krisengebieten genannt.
                </p>
                <p>
                    Wir, die Gründerinnen des freien Jugendhilfeträgers eo ipso, sehen unsere fachliche Ausrichtung
                    darin, als Person auf die einzelnen Mitglieder eines familiären Systems zu wirken. Je klarer uns
                    eigene Stärken und Schwächen in unserer Arbeit sind und je intensiver die Auseinandersetzung mit
                    denselben ist, umso authentischer und kongruenter erleben uns Adressaten und desto wirksamer sind
                    wir in unserem Handeln. Resultierend daraus, ist für uns eine übergeordnete Instanz (Supervision
                    etc.) zur Reflektion unserer Tätigkeit unverzichtbar.
                </p>

                <h2>Fachliche Leitlinien und deren Umsetzung</h2>

                <p>
                    Eo ipso gestaltet das Angebot im Rahmen der ambulanten Hilfen zur Erziehung flexibel am Bedarf der
                    Adressaten orientiert und gestaltet die Hilfe situations- und prozessorientiert mit den für die
                    Adressaten passenden Methoden. Maßgeblich für die Ausgestaltung des Angebotes ist die Wahrung des
                    Kindeswohls und eine positive, nachhaltige Entwicklung des familiären Systems bzw. der einzelnen
                    Adressaten auf Grundlage des Empowerment. Nicht die von außen übergestülpte vermeintlich „gute“
                    Lebenswirklichkeit kann vom Adressaten langfristig umgesetzt werden, sondern eo ipso – aus sich
                    selbst heraus entwickelte Perspektiven können vom Adressaten dauerhaft gelebt werden.
                </p>
                <p>
                    Eo ipso bietet lebensweltorientierte Hilfen zur Erziehung an, dabei werden die Faktoren Wohnumfeld,
                    Wohnverhältnisse und Infrastruktur in der Arbeit mit den Adressaten berücksichtigt. Eo ipso selbst
                    befindet sich mit seinen Räumlichkeiten im Stadtzentrum von Stolberg, einer Kleinstadt, deren Umfeld
                    und infrastrukturelle Bedingungen durch eine hohe Arbeitslosenquote, sowie einen sehr hohen Anteil
                    an Menschen mit Migrationshintergrund, geprägt ist. Da eo ipso direkt im Sozialraum Stolberg präsent
                    ist, sind uns die vor Ort vorhandenen Angebote und Vernetzungsmöglichkeiten gut bekannt.
                </p>
                <p>
                    Vorrangiger Ansatz in der sozialen Arbeit mit Familien, Kindern, Jugendlichen und jungen Erwachsenen
                    ist für eo ipso die Stärkung bzw. Wiederherstellung der Erziehungsfähigkeit, verantwortungsbewusste
                    Eigenständigkeit und eine angemessene Lebensführung.
                </p>
                <p>

            </div>


            <div *ngIf="page==3">


                <h2>Schwerpunktzielgruppen:</h2>
                <p>
                    Familien in besonderen Problemlagen, wie bestehender Suchterkrankung oder psychiatrischer
                    Erkrankung.
                    Alleinerziehende – insbesondere sehr junge Müttern mit Säuglingen - werden von eo ipso zwecks
                    Identifikation mit der Elternrolle und Stärkung der Erziehungskompetenz begleitet und beraten.
                </p>
                <p>
                    Kindern und Jugendlichen mit enorm herausforderndem Verhalten bietet eo ipso die Möglichkeit, ihr
                    Verhalten in Zusammenarbeit mit dem familiären System zu diagnostizieren und zu entschlüsseln.
                    Pädagogische und auch therapeutische Interventionen zur Änderung werden mit dem Betroffenen und der
                    Familie herbeigeführt.
                </p>
                <p>
                    Familien mit Migrationshintergrund kann eo ipso die Möglichkeit verschaffen, eine gelingende
                    Integration begleitend und unterstützend zu erleichtern.
                </p>
                <p>
                    Kinder und Eltern in hochstrittigen Trennungs- und Scheidungssituationen werden von eo ipso in
                    dieser für die Kinder extrem belastenden Situation begleitet. Primäres Ziel ist an dieser Stelle
                    eine konstruktive Kommunikation hochzerstrittener Eltern im Sinne des Kindeswohls und Kindeswillen
                    herbeizuführen und mediativ zu begleiten.
                    Kinder, die getrennt von einem oder beiden Elternteilen aufwachsen, bietet eo ipso sicheren Raum und
                    Begleitung bei Umgangskontakten.
                </p>
                <p>
                    Eo ipso bietet soziale Gruppenarbeit im kreativen, kunstpädagogischen und kunsttherapeutischen
                    Bereich für die gesamte Familie, Kinder, Jugendliche und Eltern an. Gruppenangebote im Rahmen von
                    „learning by doing“ zur Gestaltung des alltäglichen Lebens, wie zum Beispiel der Durchführung von
                    Kochgruppen, bietet eo ipso den Adressaten.
                </p>
                <p>
                    Im Rahmen von vom Jugendamt in Auftrag gegebenen „Clearings“ – der Klärung von konkreten
                    Fragestellungen, insbesondere auch zur Sicherung des Kindeswohles – garantiert eo ipso eine
                    fundierte Diagnostik und Dokumentation diesbezüglicher Fakten sowie die Aussprache begründeter
                    Empfehlungen.
                </p>
                <p>
                    Diese Angebote setzen die Beantragung der Hilfe zur Erziehung nach § 27 ff. SGB VIII von den
                    Erziehungsberechtigten - in der Regel auf der Basis der Freiwilligkeit – beim zuständigen Jugendamt
                    voraus.
                </p>
                <p>

            </div>

            <div *ngIf="page==4">


                <h2>Konkretisierung von Inhalt und Umfang der sozialpädagogischen Leistung differenziert nach direkter
                    und indirekter Tätigkeit</h2>

                <h3>Direkte Tätigkeit</h3>
                <p>
                    Die Voraussetzung für den Beginn der Arbeit mit den Adressaten ist das Hilfeplangespräch (HPG).
                    Durch die gemeinsame Zielvereinbarung zwischen den Adressaten der Hilfe, dem Jugendamt und den
                    Fachkräften von eo ipso wird ein erster Kontrakt gebildet, der im Protokoll des Hilfeplangespräches
                    festgehalten wird.
                </p>
                <p>
                    Mit Aufnahme der Tätigkeit wird die Gestaltung des Hilfeprozesses mit den Familien besprochen und
                    vorrangige Ziele formuliert. Eo ipso verfolgt hier eine konziliante Leitlinie. Konkret ausgedrückt,
                    werden die Absprachen zwischen Adressaten und eo ipso gemeinsam vereinbart, die Art der Umsetzung
                    der Zielvereinbarung wird abgesprochen. Eine interne Überprüfung der Zielvereinbarung mit den
                    Familien erfolgt nach ungefähr sechs Wochen. Im gemeinsamen Prozess werden die Fachkräfte mit den
                    Adressaten besprechen, inwieweit die Ziele noch aktuell sind oder aktualisiert werden sollten. Hier
                    ist eine kritische Auseinandersetzung im Hinblick auf die Notwendigkeit und Beibehaltung der Ziele
                    im Interesse der Kinder erforderlich. Eo ipso hat großes Interesse daran, die Umsetzung der Ziele im
                    Arbeitsprozess begleitend anhand passender Instrumente zu evaluieren und zur Qualitätssicherung zu
                    protokollieren.
                    Am Ende der Hilfeleistung erfolgt mit den Familien und/oder Kindern und Jugendlichen eine Auswertung
                    der sozialpädagogischen Arbeit. Das Ergebnis wird dokumentiert und an den zuständigen Sachbearbeiter
                    des Jugendamtes vor dem anstehenden Hilfeplangespräch zugeleitet. Grundsätzlich erhält der Träger
                    der öffentlichen Jugendhilfe einen Bericht zum Entwicklungsstand der Familie.
                </p>
                <p>
                    Die Fachkräfte von eo ipso haben während ihrer bisherigen Tätigkeit in der ambulanten Jugendhilfe
                    gute Erfahrungen damit gemacht, die Familien mit zwei Fachkräften zu begleiten.
                    Bedarfsorientiert werden in der Regel zwei professionelle Fachkräfte mit der Familie betraut sein,
                    wobei ein regelmäßiger Austausch über den Entwicklungsstand der Familie selbstverständlich ist.
                    Resultat aus der Arbeit im Zweierteam ist die objektivere Sicht auf das System und „blinde Flecken“
                    im Arbeitsprozess werden frühzeitig erkannt. Wie eine mögliche Zuständigkeit der Fachkräfte im
                    Arbeitsprozess (z.B. Elternarbeit/ Arbeit mit dem Kind) aufgeteilt wird, kann bereits im
                    Hilfeplangespräch erfolgen, jedoch ist dies auch prozessbegleitend veränderbar. Steigen beide
                    Sozialarbeiterinnen aktiv in die Tätigkeit mit einer Familie ein, wird dies mit den Klienten
                    besprochen.
                </p>
                <p>
                    In der Arbeit mit unseren Adressaten halten wir uns strikt an die Schweigepflicht gegenüber Dritten.
                    Die Adressaten werden über den Inhalt von Berichten und Tischvorlagen vor der Vorlage beim Jugendamt
                    informiert. Die Kommunikation im Rahmen von Vernetzung (z.B. mit Kinderärzten, Schulen etc.)
                    bedürfen einer beiderseitigen Schweigepflichtentbindung. Eo ipso arbeitet möglichst offen mit den
                    Adressaten und legt Wert auf Transparenz, folglich binden wir unsere Adressaten möglichst in
                    sämtliche sie betreffenden Gespräche mit Institutionen ein.
                </p>
                <p>
                    Die Adressaten werden zu Beginn der Hilfe darüber informiert, dass bei Kindeswohlgefährdung die
                    Verschwiegenheit außer Kraft gesetzt ist. Beim Verdacht auf eine Kindeswohlgefährdung wird
                    wenigstens eine der beiden anderen Gründerinnen informiert und zur Beratung hinzugezogen. Im
                    Bedarfsfall wird dann so schnell wie möglich die zuständige Stelle informiert. Wenn sicher
                    ausgeschlossen ist, dass dies dem betroffenen Kind nicht schadet, werden die Eltern des Kindes über
                    die Gefährdungseinschätzung und die Weitergabe der betreffenden Informationen an das Jugendamt
                    informiert.
                </p>
                <p>
                    Die Vertretung im Urlaubs- und Krankheitsfall ist durch die Dreierkonstellation des eo
                    ipso-Leitungsteams sicher gewährleistet.
                </p>

                <h3>Indirekte Tätigkeiten:</h3>
                <p>
                    Eo ipso verpflichtet sich zur regelmäßigen Supervision mit einem externen qualifizierten Supervisor
                    nach Bedarf, spätestens jedoch im Abstand von sechs bis maximal acht Wochen. Zur Reduzierung der
                    Komplexität in den Familien und um eigene Verstrickungen zu erkennen, erachtet eo ipso dieses
                    qualitätssichernde Instrument in der sozialen Arbeit als notwendig und unverzichtbar. Analog dazu
                    führt eo ipso kollegiale Fachberatung bei Bedarf - spätestens alle zwei Wochen durch. Aus der
                    Erfahrung heraus, können hier bereits dienliche Hinweise im Umgang mit den Menschen, welche der
                    freie Jugendhilfeträger eo ipso begleitet und berät, erfolgen. Fragestellungen und eigene Haltungen
                    werden im Kollegenkreis sachlich besprochen und als Idee mit in den Arbeitsprozess integriert.
                    Eo ipso sieht sich in enger Kooperation mit den zuständigen Kinder- und Jugendpsychiatrischen
                    Einrichtungen im stationären wie im ambulanten
                    Bereich, sowie mit sozialpädiatrischen Institutionen, da sie grundlegende Aussagen zum Gesundheits-
                    und Entwicklungszustandes eines Kindes treffen können. Desweiteren stellt eo ipso – in
                    Zusammenarbeit mit den Familien bzw. für diese transparent gestaltet – Vernetzung zu sämtlichen
                    Institutionen her, die einer positiven Entwicklung der Familie dienlich sein könnten.
                </p>


            </div>


            <div *ngIf="page==5">

                <h3>Methodenrepertoire</h3>
                <p>
                    Die Gründerinnen von eo ipso, verfügen durch langjährige Berufserfahrung und vielfältige angewandte
                    Weiterbildungen und Qualifikationen über ein breitgefächertes Angebot an Methoden und Techniken.
                </p>
                <p>
                    Unserer systemischen Grundhaltung entsprechend haben wir das systemische Methodenrepertoir
                    verinnerlicht und leben dieses alltäglich in unserer Arbeit mit den Klienten. Dieses führen wir im
                    Folgenden nicht im Einzelnen auf.
                </p>
                <p>
                    Hier nur ansatzweise Beispiele der von uns angewendeten Techniken:
                </p>

                <ul>
                    <li> Unterschiedliche Kommunikationsmethoden wie: Kommunikationsbilder, Interviewtechniken,
                        Reflecting-Team, nonverbale Kommunikationstechniken aus dem pädagogisch-kunsttherapeutischen
                        Bereich</li>
                    <li> Biographiearbeit durch Timeline , Genogrammarbeit, speziell die Herleitung eines Genogramms
                        durch für Kinder und Jugendliche ansprechende Methoden und Skulpturarbeiten, Skalierungsbögen
                        und Figurenbilder, um die Stellung des Kindes zu erkennen,</li>
                    <li> Problembilder und Ressourcenbilder bildnerisch darstellen, Familienwappen malen, um das Wir-
                        Gefühl zu stärken</li>
                    <li> Zur Stärkung der Kinder und Jugendlichen hypno- therapeutische Übungen oder die Arbeit mit
                        Handpuppen, um im Spiel dem kindlichen Erleben Ausdruck zu verleihen.</li>
                    <li> Marte Meo Techniken </li>
                    <li> Integration der pädagogischen Kunsttherapie zur Diagnostik und Hypothesenstellung im
                        Arbeitsprozess</li>
                </ul>
                et cetera …

                <p>
                    Die Anwendung der unterschiedlichen Methoden und Techniken dienen dazu, den Adressaten in ihrer
                    Vielfältigkeit adäquate Ausdrucksmöglichkeiten zu bieten und wird zur sozialpädagogischen
                    Diagnostik, der Beratung und der pädagogischen Arbeit angewendet. Analog dazu, sind wir durch unsere
                    Ausbildung in der Lage den Kindern und Erwachsenen durch gezielte Anwendung von Methoden alternative
                    kompensatorische Angebote zu unterbreiten, die ihnen nicht gemachte aber eventuell notwendige
                    Erfahrungen erlauben. Dies dient durchaus der Entwicklung der Persönlichkeit, ist jedoch deutlich
                    von der psychotherapeutischen Intervention abzugrenzen.
                </p>

                <h2>Zusammenarbeit mit dem öffentlichen Träger</h2>

                <p>
                    Bereits unter dem Punkt der direkten Tätigkeit wird der Beginn der Zusammenarbeit zwischen dem
                    Träger der öffentlichen Jugendhilfe und der freien Jugendhilfe beschrieben.
                    Unmittelbare Kontaktaufnahme zum Träger der öffentlichen Jugendhilfe erfolgt während des
                    Arbeitsprozesses mit den Adressaten bei einer Kindeswohlgefährdung nach 8a SGB VIII und hat eine
                    Gefährdungseinschätzung zum Schutze des Kindes zur Folge.
                    Sind die Kindeseltern nicht in der Lage ein kontraproduktives und nicht der Entwicklung förderndes
                    Verhalten einzustellen, sieht sich eo ipso verpflichtet, ein Fachgespräch mit den Zuständigen des
                    Jugendamtes zu führen, um frühzeitig weitere Interventionen zur Sicherung des Kindeswohls
                    einzuleiten. Die Klienten werden nach Abwägung der Fachkräfte direkt mit einbestellt oder ein
                    zweites gemeinsames Gespräch in Anwesenheit der Mitarbeiter des Jugendamtes und des freien Trägers
                    der Jugendhilfe wird zur Erhaltung der Transparenz gegenüber den Klienten, anberaumt.
                </p>
                <p>
                    Ergänzend wird eo ipso die Adressaten zu Beginn der Hilfe darauf hinweisen, dass aus fachlicher
                    Sicht die Rückmeldung seitens der Adressaten an eo ipso, sowie den zuständigen Sachbearbeiter des
                    Jugendamtes, bei nicht zu klärenden gegenseitigen Vorstellungen legitim und durchaus im Interesse
                    einer positiven Veränderung der Klienten sein kann.
                </p>
                <p>


            </div>


            <div *ngIf="page==6">

                <h2>Personelle Ausstattung</h2>

                <p>
                    Die persönliche Eignung sowohl nach §72 SGB VIII als auch nach §72a SGB VIII ist gegeben und wird
                    für gegebenenfalls zukünftige zusätzlich Beschäftigte garantiert.
                    Aus den Kurzprofilen der Gründerinnen (Seite 8 – 10 dieser Leistungsbeschreibung) wird die fachliche
                    Eignung von eo ipso dargelegt und mit den entsprechenden Zertifikaten am Ende der
                    Leistungsbeschreibung belegt.
                    Ein erweitertes polizeiliches Führungszeugnis sämtlicher Mitarbeiter legt eo ipso den Auftraggebern
                    regelmäßig im Rahmen der rechtlichen Bestimmungen vor.
                </p>

                <h2>Die sächliche und räumliche Ausstattung</h2>

                <p>
                    Je nach Bedarf und Notwendigkeit - und somit in der Regel - findet die Hilfe im Lebensbereich der
                    Adressaten statt. Eo ipso bieten zusätzlich Räumlichkeiten an, die den Fachkräften und Familien
                    alternative Aufenthaltsmöglichkeiten zur Beratung und für gemeinsame Gruppenangebote, sowie der
                    Durchführung begleiteter Umgangskontakte bieten. Analog werden die Räume dazu benutzt,
                    familientherapeutisch und kunstpädagogisch mit den Adressaten zu arbeiten.
                    Eo ipso stellt vielfältige Materialien für die kreative Arbeit mit den Adressaten zur Verfügung.
                </p>


                <h2>Leistungsumfang und Kosten</h2>
                <p>
                    Eo ipso begleitet Familien an deren Bedarf orientiert. Die Familien erhalten die Zeit, die sie zur
                    nachhaltigen Entwicklung benötigen. Eo ipso ist bemüht kostengünstig und dennoch effizient für die
                    Familien zu arbeiten.
                    Eo ipso verhält sich nach der Maxime: „Soviel wie nötig und nicht mehr als nötig“.
                </p>
            </div>

        </div>


    </div>


</section>